import { createWebHistory, createRouter } from "vue-router";
import CockpitPage from "./views/Cockpit.vue";
import CountyMap from "./views/CountyMap.vue";
import GlobalMap from "./views/GlobalMap.vue";
import PageNotFound from "./components/PageNotFound.vue";
import OidcCallback from "./views/OidcCallback.vue";
import UnauthUser from "./components/UnauthUser.vue";
import OidcCallbackError from "./views/OidcCallbackError.vue";
import { vuexOidcCreateRouterMiddleware } from "vuex-oidc";

import store from "@/store";

const routes = [
  // {
  //   path: "/",
  //   name: "GlobalMap",
  //   component: GlobalMap,
  //   props: true,
  // },
  // {
  //   path: "/countymap/:country",
  //   name: "CountyMap",
  //   component: CountyMap,
  //   props: true,
  // },
  {
    path: "/",
    name: "CountyMap",
    component: CountyMap,
    props: (route) => ({ country: route.query.country || "US" }),
  },
  {
    path: "/global",
    name: "GlobalMap",
    component: GlobalMap,
  },
  {
    path: "/cockpit/:country/:area/:selecteddivision",
    name: "CockpitPage",
    component: CockpitPage,
    props: true,
  },
  {
    path: "/login", // Needs to match redirectUri in you oidcSettings
    name: "login",
    component: OidcCallback,
  },
  // {
  //   path: "/oidc-popup-callback", // Needs to match popupRedirectUri in you oidcSettings
  //   name: "oidcPopupCallback",
  //   component: OidcPopupCallback,
  // },
  {
    path: "/oidc-callback-error", // Needs to match redirect_uri in you oidcSettings
    name: "oidcCallbackError",
    component: OidcCallbackError,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/unauth",
    name: "UnauthUser",
    component: UnauthUser,
    meta: {
      isPublic: true,
    },
  },
  {
    path: "/:catchAll(.*)*",
    name: "PageNotFound",
    component: PageNotFound,
  },
];

// const router = new Router({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes,
// });

var router = createRouter({
  history: createWebHistory(),
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store, "oidcStore"));

router.beforeEach((to, from, next) => {
  // console.log("store userInGroup", store.getters["oidcStore/userInGroup"]);
  // console.log("store oidcUser", store.getters["oidcStore/oidcUser"]);

  // console.log(from.name, to.name, next.name);

  if (store.getters["oidcStore/oidcIdToken"]) {
    if (to.name !== "UnauthUser" && !store.getters["oidcStore/userInGroup"]) {
      next({ name: "UnauthUser" });
    } else {
      next();
    }
  } else {
    next();
  }
});

export default router;
